module.exports = __webpack_public_path__ + "img/sofort.3ddf4a10.svg";